module.exports = __webpack_public_path__ + "img/lover.0c35baa0.png";